import React from "react";
import { View, StyleSheet, Platform } from "react-native";
import RText from "../components/RText";
import variables from "../styles/variables";
import Toast from "react-native-toast-message";
import { useResponsive } from "../hooks/useResponsive";

// JSDOC
/**
 * ToastConfig object defines the configuration for toast notifications.
 * It includes custom components for error and success toasts. we can
 * have as many as we like, i.e tomato: () => <View>Tomato</View>
 *
 * @constant
 * @type {Object}
 * @property {Function} error - Custom component for error toast.
 * @property {Function} success - Custom component for success toast.
 *
 * Usage:
 *    toastError("💩 An error occurred");
 *    toastSuccess("✅ Operation was successful");
 *
 */
export const ToastConfig = {
  error: ({ props }) => (
    <View style={[styles.banner, styles.error]}>
      <RText family="secondary" weight="bold" style={styles.bannerText}>
        {props.title}
      </RText>
    </View>
  ),
  success: ({ props }) => (
    <View style={[styles.banner, styles.success]}>
      <RText family="secondary" weight="bold" style={styles.bannerText}>
        {props.title}
      </RText>
    </View>
  ),
};

/**
 * ToastManager component to manage toast notifications in the application.
 * It uses react-native-toast-message for displaying error and success messages.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The children components to be rendered inside the ToastManager.
 * @returns {JSX.Element} The rendered ToastManager component.
 */
export default function ToastManager({ children }) {
  const { isMediumAndUp } = useResponsive();

  const BOTTOM_OFFSET = Platform.OS === "web" && isMediumAndUp ? 0 : 70; // Adjust offset for web platform

  return (
    <>
      {children}
      <Toast
        config={ToastConfig}
        bottomOffset={BOTTOM_OFFSET}
        position={"bottom"}
        visibilityTime={5000}
        autoHide
        swipeable
      />
    </>
  );
}

const styles = StyleSheet.create({
  banner: {
    width: "97%",
    maxWidth: 400,
    paddingVertical: 10,
    paddingHorizontal: 16,
    borderRadius: 8,
    marginVertical: 6,
    height: 50,
    justifyContent: "center",
    alignSelf: "center",
  },
  bannerText: {
    fontSize: 14,
    color: "#fff",
  },
  error: {
    backgroundColor: variables.colors.toasts.error,
  },
  success: {
    backgroundColor: variables.colors.toasts.success,
  },
});
